import React from "react";
import Footer from "../Component/Footer";
import Header from "../Component/Header";

function Liquid() {
    return (
        <div>
            <Header />
            {/* <img src="img/mestrual.jpg" className="img-fluid" alt="..." style={{width:"100%"}}/>
      */}

            <div className="container header-start ">
                <b>
                    <h1
                        className=" container main-text text-center"
                        style={{ color: "#911146", fontSize: "36px" }}
                    >
                        Kayunga Community Liquid Soap
                    </h1>
                </b>
                <p className="sub-text" style={{ color: "black", fontSize: "24px" }}>
                </p>
            </div>
            <Footer />
        </div>
    );
}

export default Liquid;
